import React from 'react';
import VhTypes from '../../configs/VHTypes';
import { useVHTypeConfig } from '../../vhTypeHooks';
import RootBranchingBehaviorHandler from '../../branching/RootBranchingBehaviorHandler/RootBranchingBehaviorHandler';
import RootDefaultBehaviorHandler from '../../default/RootDefaultBehaviorHandler/RootDefaultBehaviorHandler';

const RootBehaviorHandlerSelector = (props) => {
  const vhTypeConfig = useVHTypeConfig();
  if (vhTypeConfig.type === VhTypes.BRANCHING) {
    return <RootBranchingBehaviorHandler />;
  }
  return <RootDefaultBehaviorHandler />;
};

export default RootBehaviorHandlerSelector;
